export default __webpack_public_path__ + "static/bootani2-4b47c1788d1e320d13d97891ce1c4f00.mp4";